"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const asyncDebouncer = require("@tanstack/pacer/async-debouncer");
const reactStore = require("@tanstack/react-store");
const PacerProvider = require("../provider/PacerProvider.cjs");
function useAsyncDebouncer(fn, options, selector = () => ({})) {
  const mergedOptions = {
    ...PacerProvider.useDefaultPacerOptions().asyncDebouncer,
    ...options
  };
  const [asyncDebouncer$1] = react.useState(
    () => new asyncDebouncer.AsyncDebouncer(fn, mergedOptions)
  );
  asyncDebouncer$1.fn = fn;
  asyncDebouncer$1.setOptions(mergedOptions);
  const state = reactStore.useStore(asyncDebouncer$1.store, selector);
  react.useEffect(() => {
    return () => {
      asyncDebouncer$1.cancel();
    };
  }, [asyncDebouncer$1]);
  return react.useMemo(
    () => ({
      ...asyncDebouncer$1,
      state
    }),
    // omit `store` in favor of `state`
    [asyncDebouncer$1, state]
  );
}
exports.useAsyncDebouncer = useAsyncDebouncer;
//# sourceMappingURL=useAsyncDebouncer.cjs.map
